import { CoachLesson } from "./CoachLesson";

export class CoachLessonInfoResponse {
  constructor({ coachLesson, lessonType, timetable }) {
    this.coachLesson = coachLesson ? new CoachLesson(coachLesson) : null;
    this.lessonType = lessonType;
    this.timetable = timetable;
  }
}
